import { z } from 'zod';
import { CUSTOMER_INDUSTRIES } from '../constants/customers.js';
import { idSchema } from './common.js';
import { supportedLocaleSchema } from './plm-material.js';
export const customerCategoryWriteSchema = z
    .object({
    name: z.string().trim().min(1).max(120),
    translations: z.record(supportedLocaleSchema, z.string().trim().min(1).max(120)).default({}),
    isActive: z.boolean().default(true),
    sortOrder: z.number().int().min(0).max(10000).default(0),
})
    .strict();
export const customerCategoryIdSchema = z.union([idSchema, z.enum(CUSTOMER_INDUSTRIES)]);
export const customerCategorySchema = customerCategoryWriteSchema
    .extend({
    id: customerCategoryIdSchema,
    code: z.string(),
    usageCount: z.number().int().nonnegative(),
})
    .strip();
export const customerCategoryListSchema = z.object({ data: z.array(customerCategorySchema) });
export function customerCategoryLabel(category, locale) {
    return category.translations[locale.split('-')[0] ?? locale] ?? category.name;
}
//# sourceMappingURL=customer-category.js.map